import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import "./job-opening-card.style.scss";
export default function JobOpeningCard({
  applied,
  data,
  saving,
  onStarClick,
  handleApply,
}) {
  const [localData, setLocalData] = React.useState({});
  const context = React.useContext(MainContext);
  const { appliedJobs, savedJobs } = context;

  React.useEffect(() => {
    if (!data) return;

    let match = savedJobs.indexOf(data.jobId);
    let match2 = appliedJobs.indexOf(data.jobId);
    if (match == "-1" && match2 == "-1") {
      setLocalData(data);
    } else {
      setLocalData({
        ...data,
        saved: match == "-1" ? false : true,
        applied: match2 == "-1" ? false : true,
      });
    }
  }, [data, savedJobs, appliedJobs]);
  return (
    <div className="job-opening-card-main">
      <div className="jocm-header">
        <div>
          <img src={Images.menTree} />
        </div>
        <div>
          {!localData?.jobType ? "" : <button>{localData?.jobType}</button>}
          <img
            onClick={() => {
              onStarClick();
            }}
            height="20"
            width="20"
            src={
              saving
                ? "https://img.icons8.com/ios-glyphs/48/000000/refresh.png"
                : localData?.saved
                ? "https://img.icons8.com/color/48/000000/filled-star--v1.png"
                : "https://img.icons8.com/ios/150/000000/star--v2.png"
            }
          />
        </div>
      </div>
      <h5 className="job-title" title={localData?.jobTitle || "Title"}>
        {localData?.jobTitle || "Title"}
      </h5>
      <p className="institute-name" title={localData?.clientName || "School"}>
        {localData?.clientName || "School"}
      </p>
      <h6 className="location">
        <img src={Images.blueLocation} />
        <span>{localData?.location}</span>
      </h6>
      <div className="jocm-info">
        {!localData?.custField1?"":<p>
          <img src={Images.blueBook} />
          <span title={localData?.custField1 }>
            {localData?.custField1 }
          </span>
        </p>
        }
        <p>
          <img src={Images.groupLogo} />
          <span title="10-50 Staffs">10-50 Staffs</span>
        </p>
        <p>
          <img src={Images.manWIthStars} />+
          <span
            title={`${
              !localData?.minWorkExp ? "0" : localData?.minWorkExp
            } Yrs exp`}
          >
            {!localData?.minWorkExp ? "0" : localData?.minWorkExp} Yrs exp
          </span>
        </p>
      </div>
      <div className="salary-range">
        <p>Salary Range</p>
        <h5>
          { !localData?.minSalary?"0K": localData?.minSalary?.substring(0, 2) + "K"} -{" "}
          {!localData?.maxSalary
            ? "NA"
            : localData?.maxSalary?.substring(0, 2) + "K"}
        </h5>
      </div>
      <div className={`jocm-other-info ${applied ? "d-none" : ""}`}>
        <p>
          <img src={Images.groupLogo} />
          <b>{data?.appliedCount || "0"}</b> Applied
        </p>
        <p>
          <img src={Images.eyeLogo} />
          <b>{data?.jobViewCount || "0"}</b> Views
        </p>
      </div>
      {localData.applied ? (
        <button className={`apply-button applied ${applied ? "d-none" : ""}`}>
          <p>Applied</p>
        </button>
      ) : (
        <button
          onClick={() => handleApply()}
          className={`apply-button ${applied ? "d-none" : ""}`}
        >
          <p>Apply now</p>
        </button>
      )}
      <button className={`view-button ${applied ? "colored-button" : ""}`}>
        <Link to={`/user/description/${localData?.jobId}`}>View Details</Link>
      </button>
    </div>
  );
}
